import {AxiosError} from 'axios';
import {POST_USER_GROUP_AUTHORITIES_URL} from 'web-library/constants/apiUrls';
import {
  UserGroupAccessMatrixRequest
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostUserGroupAccessMatrix = ({uuid, onError, onSuccess}: Input) => {
  const postUserGroupAccessMatrix = async (reqBody: UserGroupAccessMatrixRequest) => {
    const res = await axiosClient.post<void>(POST_USER_GROUP_AUTHORITIES_URL(uuid), reqBody);

    return res.data;
  };

  return useCustomMutation(postUserGroupAccessMatrix, {
    onSuccess,
    onError,
  });
};
